module.exports = __webpack_public_path__ + "static/media/icn_mainnav_favourites_small.2a2f23e0.svg";